import axios from "axios";

const raw = process.env.REACT_APP_BACKEND_URL;
// Empty string = same domain (nginx proxies /api) — best for low-cost VPS hosting
const BACKEND_URL =
  raw === "" ? "" : (raw || "http://localhost:8000").replace(/\/$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
